// Texty sticky lišty „Do košíku" na detailu produktu (stickyAtc.js).
export default {
  addToCart: 'Do košíku',
  /** aria-label regionu lišty */
  region: 'Rychlý nákup',
};
